// extracted by mini-css-extract-plugin
module.exports = {"content":"ForResearches_content__dD8xL"};